import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  bottomRowWrapper: {
    flex: 1,
    height: Theme.px(472),
    marginLeft: Theme.px(90),
    minHeight: Theme.px(472),
    width: Theme.px(1848),
  },
});
